
import React, {} from 'react';
import _ from 'lodash';

function AddressSummary(props) {
    const { address } = props;

    return (
        !_.isUndefined(address) ?
        <div>
            <div>{address.addressLine1}</div>
            <div>{address.addressLine2}</div>
            <div>{address.addressLine3}</div>
            <div>{address.city }</div>
            <div>{address.state }</div>
            <div>{address.postalCode}</div>
        </div>
        : null
    );
}

AddressSummary.propTypes = {
    
};

AddressSummary.defaultProps = {

};

export default AddressSummary;
